import {
  TeamMemberCard as CardWrapper,
  MemberImage,
  CardLink,
  MemberInfoWrapper,
  MemberName,
  MemberTitle,
  MemberInfo,
  BookConsultationButton,
} from "../styles";
import { parsePipeList } from "../../../../PractitionerProfile/utils";
import { CONSULTATION_COPY } from "../../../../../../constants/consultation";
import { useBookablePractitioners } from "../../../../../../hooks/useBookablePractitioners";

const TeamMemberCard = ({ practitioner, onMeetClick, onBookConsultation }) => {
  // Booking links live on the backend now, so the card asks which
  // practitioners are bookable rather than reading a link it no longer has.
  const { isBookable } = useBookablePractitioners();
  return (
  <CardWrapper>
    <MemberImage
      src={practitioner.img}
      alt={practitioner.name}
      // object-position chosen by the practitioner in the dashboard (falls back
      // to the styled default 'top' when unset).
      style={
        practitioner.avatarPosition
          ? { objectPosition: practitioner.avatarPosition }
          : undefined
      }
    />
    <CardLink className="card-link" onClick={onMeetClick}>
      Meet {practitioner.name.split(" ")[0]}
    </CardLink>
    <MemberInfoWrapper>
      <MemberName>{practitioner.name}</MemberName>
      <MemberTitle>{practitioner.title}</MemberTitle>
      {practitioner.hourlyRate && (
        <MemberInfo>
          <MemberTitle>Hourly Rate:&nbsp;</MemberTitle>${practitioner.hourlyRate}
        </MemberInfo>
      )}
      {practitioner.focusAreas && (
        <MemberInfo>
          <MemberTitle>Focus Areas:&nbsp;</MemberTitle>
          {parsePipeList(practitioner.focusAreas).join(" | ")}
        </MemberInfo>
      )}
      {practitioner.approach && (
        <MemberInfo>
          <MemberTitle>Approach:&nbsp;</MemberTitle>
          {parsePipeList(practitioner.approach).join(" | ")}
        </MemberInfo>
      )}
      {isBookable(practitioner.name) && (
        <BookConsultationButton onClick={onBookConsultation}>
          {CONSULTATION_COPY.book}
        </BookConsultationButton>
      )}
    </MemberInfoWrapper>
  </CardWrapper>
  );
};

export default TeamMemberCard;
